import { useState } from "react"
import CustomModal from "components/new-stuff/ui/modals/CustomModal"
import { Button } from "components"
import { Input } from "antd"
import { useMutation } from "@tanstack/react-query"
import { ewaAxiosInstance } from "utils/request"
import { onQueryError } from "utils/utils"
import { queryClient } from "index"

interface Props {
  open: boolean
  onClose: () => void
  timesheetId: number | null
  timesheetQueryKey: string
}

const AddReasonModal = ({
  open,
  onClose,
  timesheetId,
  timesheetQueryKey,
}: Props) => {
  const [reason, setReason] = useState("")
  const [reasonSubmitted, setReasonSubmitted] = useState(false)

  const { mutate, isLoading } = useMutation({
    mutationFn: async () => {
      return (
        await ewaAxiosInstance.post(
          `/v1/time-attendance/employee/timesheet/${timesheetId}/flag-reason`,
          {
            reason,
          }
        )
      ).data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [timesheetQueryKey] })
      onClose()
      setReasonSubmitted(true)
    },
    onError: onQueryError,
  })

  const handleClose = () => {
    onClose()
    setReasonSubmitted(false)
    setReason("")
  }

  return (
    <CustomModal
      open={open}
      onCancel={handleClose}
      title={!reasonSubmitted ? "Reason for flags" : "Reason"}
    >
      <div className="flex flex-col gap-3">
        <div>
          {reasonSubmitted ? (
            <p className="text-sm text-padeBlack mb-2">{reason}</p>
          ) : (
            <>
              <p className="text-sm text-padeBlack mb-2">
                Due to the nature of your clock in there are a few flags
                attached to this timesheet entry, kindly provide an explanation
                below
              </p>
              <label className="text-sm font-semibold text-padeBlack mb-1">
                Reason
              </label>
              <Input.TextArea
                value={reason}
                rows={3}
                maxLength={150}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter reasons for your flags"
                className="text-sm"
              />
              <p className="text-xs text-slate-400">
                Note: You can't edit your reason after saving
              </p>
            </>
          )}
        </div>
        {reasonSubmitted ? (
          <Button
            onClick={handleClose}
            className="text-black px-6 py-2 rounded-md text-sm font-semibold w-full border border-[#CAD5E2]"
          >
            Close
          </Button>
        ) : (
          <Button
            onClick={() => mutate()}
            submitting={isLoading}
            disabled={!reason || isLoading}
            className="bg-primary500 text-white px-6 py-2 rounded-md text-sm font-semibold w-full disabled:opacity-50"
          >
            Save reason
          </Button>
        )}
      </div>
    </CustomModal>
  )
}

export default AddReasonModal
